module.exports = __webpack_public_path__ + "media/images/flags/16/Brunei-3cde1cbeb16559e04da85952b2aa2880.png";